/**
 * Class description
 *
 * Created: 2017-09-25
 * @author jonas
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class ReelHelper {

    /**
     * Finds all instances of a specific symbol on reelsSet and returns their positions.
     *
     * @param reelSet Reelset to search for symbol in.
     * @param {string} symId Id of the symbol you want to find.
     * @returns {[number , number][]} Positions of found symbols, coordinates are only in the visible range. Can be
     *     empty array.
     */
    static findSymbolsInReelSet(reelSet:string[][], symId:string):[number, number][] {
        let result:[number, number][] = [];

        let visibleSymbols = GameConfig.instance.SYMBOLS_NUM_IN_REEL[2];
        let symbolsBefore = GameConfig.instance.SYMBOLS_NUM_IN_REEL[1];


        for(let i:number = 0; i < reelSet.length; i++) {
            for(let j:number = symbolsBefore; j < (symbolsBefore + visibleSymbols); j++) {
                if(reelSet[i][j] == symId) {
                    result.push([i, j - symbolsBefore]);
                }
            }
        }
        return result;
    }
}